import * as React from 'react';
import * as ReactDom from 'react-dom';

import './app.scss';

import App from './app';

ReactDom.render(
	<App />,
	document.getElementById('scitani-2021-root')
);